import { createApp } from 'vue'

import '@unocss/reset/tailwind.css'
import '@daysmart/daysmart-vue-components/dist/icons.css'
import './core/styles/fonts.scss'
import 'virtual:uno.css'

// import './core/styles/scss/main.scss'

import BaseApp from './BaseApp.vue'
import { install as blockingWidget } from './core/modules/blocking/0-widget'
import { install as directives } from './core/modules/directives'
import { install as i18nModule } from './core/modules/i18n'
import { install as dsComponentsModule } from './core/modules/ds-components'
import { install as keyboardTrapModule } from './core/modules/v-kbd-trap'
import { install as vueQueryModule } from './core/modules/vue-query'

// necessary for unocss to recognize css classes
import.meta.glob('../node_modules/@daysmart/daysmart-vue-components/dist/*.js', { eager: true })

const baseApp = createApp(BaseApp)

await blockingWidget(baseApp)

const modules = [directives, i18nModule, dsComponentsModule, keyboardTrapModule, vueQueryModule]
modules.forEach(i =>
  i(baseApp),
)

baseApp.mount('#base-app')
